import React, { useEffect, useState } from 'react';
import { Culture } from 'constants/interface';
import { useDispatch, useSelector } from 'hooks/store';
import {
  cleanCulturesAction,
  culturesEntitiesSelector,
  culturesIdsSelector,
  getCultureListAction,
  isLoadingCulturesSelector,
} from 'state/slices/products';
import { Select, Spinner } from 'UI';
import { FormItemProps } from 'antd';

import {
  RemoteSelectContent,
  RemoteSelectSpinnerContainer,
} from './style';

interface CultureSelectSearchProps {
  onSelect?: (culture: Culture) => void
  form?: {
    FormItem: React.ComponentType<FormItemProps>
    formItemProps: FormItemProps
  }
  disabled?: boolean
  initialSelected?: Culture
}

const CultureSelectSearch = ({
  onSelect = () => {},
  form,
  disabled,
  initialSelected,
}: CultureSelectSearchProps): JSX.Element => {
  const dispatch = useDispatch();

  const culturesEntities = useSelector(culturesEntitiesSelector);
  const culturesIds = useSelector(culturesIdsSelector);
  const isLoadingCultures = useSelector(isLoadingCulturesSelector);
  const cultures = culturesIds
    .map((cultureId) => culturesEntities[cultureId])
    .filter((culture) => !!culture) as Culture[];

  const [internalLoading, setInternalLoading] = useState(false);

  const [selectedCulture, setSelectedCulture] = useState<Culture | undefined>(initialSelected);
  const [isDropdownOpened, setDropdownOpened] = useState<boolean>(false);

  const initialSelectedId = initialSelected?.id;

  useEffect(() => {
    // if (initialSelectedId && culturesEntities[initialSelectedId]) {
    if (initialSelectedId) {
      setSelectedCulture(initialSelected);
    }
  }, [initialSelectedId]);

  const [
    cultureSearchTimeout,
    setCultureSearchTimeout,
  ] = useState<number>();
  const onCultureSearch = (search: string) => {
    if (!search) {
      dispatch(cleanCulturesAction());
    } else {
      dispatch(cleanCulturesAction());
      setInternalLoading(true);
      window.clearTimeout(cultureSearchTimeout);
      const searchTimeout = window.setTimeout(() => {
        dispatch(getCultureListAction({
          search,
          isPaginated: false,
        }));
        setInternalLoading(false);
      }, 500);
      setCultureSearchTimeout(searchTimeout);
    }
  };

  const selectedCultureOption = selectedCulture
    ? [selectedCulture]
    : [];

  const selectItems = isDropdownOpened
    ? cultures
    : selectedCultureOption;

  const selectElement = (
    <Select
      placeholder="Selecione uma cultura"
      // showArrow={false}
      showSearch
      onBlur={() => dispatch(cleanCulturesAction())}
      onDropdownVisibleChange={(isOpen) => setDropdownOpened(isOpen)}
      onSearch={onCultureSearch}
      onSelect={(cultureId) => {
        const curSelectedCulture = culturesEntities[cultureId];
        if (curSelectedCulture) {
          setSelectedCulture(curSelectedCulture);
          onSelect(curSelectedCulture);
        }
      }}
      filterOption={false}
      notFoundContent={null}
      loading={internalLoading}
      disabled={disabled}
      dropdownRender={(menu) => (
        <div>
          <RemoteSelectContent>
            {menu}
            {(internalLoading || isLoadingCultures) && (
              <RemoteSelectSpinnerContainer>
                <Spinner />
              </RemoteSelectSpinnerContainer>
            )}
          </RemoteSelectContent>
        </div>
      )}
    >
      {selectItems.map((cultureOption) => (
        <Select.Option
          value={cultureOption.id}
          key={cultureOption.id}
          label={cultureOption.name}
        >
          {cultureOption.name}
        </Select.Option>
      ))}
    </Select>
  );

  return (
    form ? (
      <form.FormItem
        {...form.formItemProps}
      >
        { selectElement }
      </form.FormItem>
    ) : selectElement
  );
};

export default CultureSelectSearch;
